module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_6.24aab5f9.png";